import { createIcon } from '@chakra-ui/icons';

export const Copy = createIcon({
  displayName: 'Copy',
  viewBox: '0 0 14 14',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M3.66667 10.3333H2C1.448 10.3333 1 9.88533 1 9.33333V2C1 1.448 1.448 1 2 1H9.33333C9.88533 1 10.3333 1.448 10.3333 2V3.66667"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeMiterlimit="10"
      />
      <path
        d="M12.0003 3.66797H4.66699C4.11471 3.66797 3.66699 4.11568 3.66699 4.66797V12.0013C3.66699 12.5536 4.11471 13.0013 4.66699 13.0013H12.0003C12.5526 13.0013 13.0003 12.5536 13.0003 12.0013V4.66797C13.0003 4.11568 12.5526 3.66797 12.0003 3.66797Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>,
  ],
});
